import ReactModal from "react-modal";
import ClearIcon from "../../assets/icons/stepsIcons/ClearIcon";
import "./modal.css";

// Modal.setAppElement('#root');
function Modal({ children, isOpen, toggle, ...props }) {
  return (
    <ReactModal
      closeTimeoutMS={200}
      isOpen={isOpen}
      overlayClassName="overlay-tab"
      className="content-tab"
      {...props}
      ariaHideApp={false}
    >
      <button className="absolute right-10 top-6" onClick={toggle}>
        <ClearIcon width="15" height="15" />
      </button>
      {children}
    </ReactModal>
  );
}

export { Modal };
